import { Map, OrderedMap } from 'immutable'
import * as actionTypes from './actionTypes'

const initialState = Map({
    all: Map({
        objects: OrderedMap({}),
        fetching: false,
        error: null,
        duplicity: null,
    }),
    current: Map({
        fetching: false,
        saving: false,
        error: null,
        id: null,
    }),
    deletion: Map({
        inProgress: false,
        error: null,
    }),
    restoring: Map({
        inProgress: false,
        error: null,
    }),
    infoByVAT: Map({
        data: null,
        inProgress: false,
        error: null,
    }),
    addresses: Map({
        data: [],
        fetching: false,
        error: null,
    }),
    contacts: Map({
        data: [],
        fetching: false,
        error: null,
    }),
    plans: Map({
        data: [],
        fetching: false,
        error: null,
    }),
    checkingDuplicity: Map({
        data: {},
        inProgress: false,
        error: null,
    }),
})

function customers(state = initialState, action) {
    switch (action.type) {
        // List
        case actionTypes.FETCH_STARTED:
            return state.setIn(['all', 'fetching'], true)
        case actionTypes.FETCH_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['all', 'objects'], action.payload)
                    .setIn(['all', 'fetching'], false)
                    .setIn(['all', 'error'], null)
            })
        case actionTypes.FETCH_REJECTED:
            return state.withMutations(map => {
                map.setIn(['all', 'fetching'], false).setIn(['all', 'error'], action.payload)
            })
        case actionTypes.FETCH_CANCELLED:
            return state.setIn(['all', 'fetching'], false)
        case actionTypes.SORTING_CHANGED:
            return state.setIn(['all', 'sorting'], action.payload)

        // One
        case actionTypes.FETCH_ONE_STARTED:
            return state.setIn(['current', 'fetching'], true)
        case actionTypes.FETCH_ONE_FULFILLED:
        case actionTypes.FETCH_ONE_REJECTED:
        case actionTypes.FETCH_ONE_CANCELLED:
            return state.setIn(['current', 'fetching'], false)

        // New/edit
        case actionTypes.SAVE_STARTED:
            return state.withMutations(map => {
                map.setIn(['current', 'saving'], true)
                    .setIn(['current', 'error'], null)
                    .setIn(['all', 'duplicity'], null)
            })
        case actionTypes.SAVE_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['current', 'saving'], false)
                    .setIn(['current', 'error'], null)
                    .setIn(['current', 'id'], action.payload.get('id'))
                    .setIn(['all', 'duplicity'], null)
                    .setIn(['all', 'objects', String(action.payload.get('id'))], action.payload)
            })
        case actionTypes.SAVE_REJECTED:
            return state.withMutations(map => {
                map.setIn(['current', 'saving'], false)
                    .setIn(['current', 'error'], action.payload)
                    .setIn(['all', 'duplicity'], null)
            })
        case actionTypes.SAVE_DUPLICITY_FOUND:
            return state.withMutations(map => {
                map.setIn(['current', 'saving'], false)
                    .setIn(['current', 'error'], null)
                    .setIn(['all', 'duplicity'], action.payload)
            })

        // Delete
        case actionTypes.DELETE_STARTED:
            return state.setIn(['deletion', 'inProgress'], true)
        case actionTypes.DELETE_FULFILLED:
            return state.deleteIn(['all', 'objects', action.payload]).withMutations(map => {
                map.setIn(['deletion', 'inProgress'], false).setIn(['deletion', 'error'], null)
            })
        case actionTypes.DELETE_REJECTED:
            return state.withMutations(map => {
                map.setIn(['deletion', 'inProgress'], false).setIn(['deletion', 'error'], action.payload)
            })

        // Restore
        case actionTypes.RESTORE_STARTED:
            return state.setIn(['restoring', 'inProgress'], true)
        case actionTypes.RESTORE_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['restoring', 'inProgress'], false)
                    .setIn(['restoring', 'error'], null)
                    .setIn(['all', 'objects', String(action.payload.get('id'))], action.payload)
            })
        case actionTypes.RESTORE_REJECTED:
            return state.withMutations(map => {
                map.setIn(['restoring', 'inProgress'], false).setIn(['restoring', 'error'], action.payload)
            })

        // Load info by VAT
        case actionTypes.LOAD_INFO_STARTED:
            return state.setIn(['infoByVAT', 'inProgress'], true)
        case actionTypes.LOAD_INFO_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['infoByVAT', 'inProgress'], false)
                    .setIn(['infoByVAT', 'error'], null)
                    .setIn(['infoByVAT', 'data'], action.payload)
            })
        case actionTypes.LOAD_INFO_REJECTED:
            return state.withMutations(map => {
                map.setIn(['infoByVAT', 'inProgress'], false).setIn(['infoByVAT', 'error'], action.payload)
            })
        case actionTypes.CLEAR_INFO:
            return state.withMutations(map => {
                map.setIn(['infoByVAT', 'inProgress'], false)
                    .setIn(['infoByVAT', 'error'], null)
                    .setIn(['infoByVAT', 'data'], null)
            })

        // Fetch customer addresses
        case actionTypes.FETCH_ADDRESSES_STARTED:
            return state.withMutations(map => {
                map.setIn(['addresses', 'fetching'], true).setIn(['addresses', 'error'], null)
            })
        case actionTypes.FETCH_ADDRESSES_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['addresses', 'fetching'], false)
                    .setIn(['addresses', 'error'], null)
                    .setIn(['addresses', 'data'], action.payload)
            })
        case actionTypes.FETCH_ADDRESSES_REJECTED:
            return state.withMutations(map => {
                map.setIn(['addresses', 'fetching'], false)
                    .setIn(['addresses', 'error'], action.payload)
                    .setIn(['addresses', 'data'], null)
            })

        // Fetch customer contacts
        case actionTypes.FETCH_CONTACTS_STARTED:
            return state.withMutations(map => {
                map.setIn(['contacts', 'fetching'], true).setIn(['contacts', 'error'], null)
            })
        case actionTypes.FETCH_CONTACTS_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['contacts', 'fetching'], false)
                    .setIn(['contacts', 'error'], null)
                    .setIn(['contacts', 'data'], action.payload)
            })
        case actionTypes.FETCH_CONTACTS_REJECTED:
            return state.withMutations(map => {
                map.setIn(['contacts', 'fetching'], false)
                    .setIn(['contacts', 'error'], action.payload)
                    .setIn(['contacts', 'data'], null)
            })

        // Fetch customer plans
        case actionTypes.FETCH_PLANS_STARTED:
            return state.withMutations(map => {
                map.setIn(['plans', 'fetching'], true).setIn(['plans', 'error'], null)
            })
        case actionTypes.FETCH_PLANS_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['plans', 'fetching'], false)
                .setIn(['plans', 'error'], null)
                .setIn(['plans', 'data'], action.payload)
            })
        case actionTypes.FETCH_PLANS_REJECTED:
            return state.withMutations(map => {
                map.setIn(['plans', 'fetching'], false)
                .setIn(['plans', 'error'], action.payload)
                .setIn(['plans', 'data'], null)
            })

        // Check duplicity
        case actionTypes.CHECK_DUPLICITY_STARTED:
            return state.setIn(['checkingDuplicity', 'inProgress'], true)
        case actionTypes.CHECK_DUPLICITY_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['checkingDuplicity', 'inProgress'], false)
                    .setIn(['checkingDuplicity', 'error'], null)
                    .setIn(['checkingDuplicity', 'data'], action.payload)
            })
        case actionTypes.CHECK_DUPLICITY_REJECTED:
            return state.withMutations(map => {
                map.setIn(['checkingDuplicity', 'inProgress'], false).setIn(['checkingDuplicity', 'error'], action.payload)
            })

        // Import headers

        case actionTypes.FETCH_IMPORT_HEADERS_STARTED:
            return state.setIn(['import', 'inProgress'], true)
        case actionTypes.FETCH_IMPORT_HEADERS_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['import', 'inProgress'], false)
                map.setIn(['import', 'error'], null)
                map.setIn(['import', 'file_id'], action.payload.file_id)
                map.setIn(['import', 'headers'], action.payload.headers)
                map.setIn(['import', 'headersDefault'], action.payload.headers_default)
            })
        case actionTypes.FETCH_IMPORT_HEADERS_REJECTED:
            return state.withMutations(map => {
                map.setIn(['import', 'inProgress'], false).setIn(['import', 'error'], action.payload)
            })
        case actionTypes.FETCH_IMPORT_HEADERS_CANCELLED:
            return state.setIn(['import', 'inProgress'], false)

        // Import values

        case actionTypes.FETCH_IMPORT_ITEMS_STARTED:
            return state.setIn(['import', 'inProgress'], true)
        case actionTypes.FETCH_IMPORT_ITEMS_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['import', 'inProgress'], false)
                map.setIn(['import', 'error'], null)
                map.setIn(['import', 'items'], action.payload.items)
            })
        case actionTypes.FETCH_IMPORT_ITEMS_REJECTED:
            return state.withMutations(map => {
                map.setIn(['import', 'inProgress'], false).setIn(['import', 'error'], action.payload)
            })
        case actionTypes.FETCH_IMPORT_ITEMS_CANCELLED:
            return state.setIn(['import', 'inProgress'], false)

        // Import

        case actionTypes.IMPORT_CUSTOMERS_STARTED:
            return state.setIn(['import', 'inProgress'], true)
        case actionTypes.IMPORT_CUSTOMERS_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['import', 'inProgress'], false)
                map.setIn(['import', 'error'], null)
            })
        case actionTypes.IMPORT_CUSTOMERS_REJECTED:
            return state.withMutations(map => {
                map.setIn(['import', 'inProgress'], false).setIn(['import', 'error'], action.payload)
            })
        case actionTypes.IMPORT_CUSTOMERS_CANCELLED:
            return state.setIn(['import', 'inProgress'], false)

        default:
            return state
    }
}

export default customers
